import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { Fetch, baseUrl } from "../../shared/Fetch";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { IModel, IModel2 } from "./TeamManagement";
import { TeamData, teamData } from "./EmptyTeam";

interface Iprops {
    singleData: teamData[],
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    inTeam: any,
    setModal: (modal: IModel2) => void,
}

export const MoveTeamMembersForm = (props: Iprops) => {
    const [selectMoveUsers,setSelectMoveUsers] = useState<Array<any>>([]);
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<teamData>, loading: boolean });
    const [disableOnSubmit,setDisableOnSubmit] = useState(false);

    let x:string | null=sessionStorage.getItem('auth') || "null";
    let loginObj=JSON.parse(x);

    useEffect(()=>{
        if(props.open){
            setSelectMoveUsers([]);
            setTableData({ tableData: props.singleData, loading: false });
        }
    },[props.open]);

    const saveToDB = async () => {

        let usersList = selectMoveUsers.map((el)=>{
            return {
                Team_ID : props.inTeam.team_ID,
                Login_ID : el.user_Login_ID,
                Status : true,
                User_Added_by : loginObj.id,
                CreatedOn: null,
            }
        });

        const validUsers = [];

        for(let i=0;i<usersList.length;i++){
            let rem = true;
            for(let j=0;j<usersList.length && j != i;j++){
                if(usersList[i].Login_ID === usersList[j].Login_ID){
                    rem = false;
                    j=usersList.length;
                }
            }
            if(rem){
                validUsers.push(usersList[i]);
            }
        }

        const removeUsers = validUsers.map((el)=>el.Login_ID);

        const params = {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            },
        };

        const response = await fetch(`${baseUrl}TeamMember_Mast?user_IDs=${removeUsers}`, params);
        if (response) {
            onHide();
            props.setModal({ open: false, singleData: TeamData })
            const resp = await Fetch("TeamMember_Mast", "POST", validUsers, null, props.toast);
            if (resp) {
                onHide();
                setDisableOnSubmit(false);
                props.toast.current.show({ severity: 'success', detail: "Added Successfully", life: 3000 });
                props.setModal({ open: true, singleData: props.inTeam })
                props.setReload(!props.reload);
            }
        } else {
            props.toast.current.show({ severity: 'error', detail: "Something Went Wrong", life: 3000 });
        }
    }

    const onHide = () => {
        props.hideDialog();
    }

    function onSubmit() {
        if(selectMoveUsers.length == 0) {
            props.toast.current.show({ severity: 'error', detail: "Please select atleast one team member", life: 3000 });
            setDisableOnSubmit(false);
        }else{
        setDisableOnSubmit(true);
        saveToDB(); 
        }
    }
    
    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header={`Add Team Members To : ${props.inTeam.team_Name}`} modal className="p-fluid" onHide={onHide}>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                className="mt-6"
                size="small" stripedRows scrollable scrollHeight="30vh"
                value={tableData.tableData}
                selection={selectMoveUsers} onSelectionChange={(e) => setSelectMoveUsers(e.value)}
                emptyMessage="No Users found."
                loading={tableData.loading}
            >
                <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                <Column header="SN." body={(data, options) => options.rowIndex + 1}/>
                <Column field="user_Name" header="Team Member Name" />
                <Column field="on_Team_Name" header="Team Name" />
                <Column field="was_Added_By" header="Added By" />
            </DataTable>
            <div className="flex flex-row-reverse w-full">
                <Button className="w-7rem flex align-items-center justify-content-center mt-3" disabled={disableOnSubmit} onClick={onSubmit}>Move</Button>
            </div>
        </Dialog>
    );
}